import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Popover } from 'antd';
import { getCategory, getSubCategory } from 'helpers/statisticsHelpers';
import classnames from 'classnames';

import styles from './styles.module.scss';

export const CalendarCell = ({
  type,
  id,
  status,
  zone,
  participants,
  structure = '',
  history,
  activityTypes,
  parkings,
}) => {
  if (!type) {
    return null;
  }
  const categories = type.reduce((acc, currentType) => {
    const category = getCategory(currentType.split(/,/)[0], activityTypes).value.categoryLabel;
    const subCategory = getSubCategory(currentType, activityTypes);

    if (Object.keys(acc).includes(category)) {
      acc[category].push(subCategory);
      return acc;
    }
    return {
      ...acc,
      [category]: [subCategory],
    };
  }, {});

  const categoriesKeys = Object.keys(categories);
  return (
    <li>
      <Popover
        placement="topLeft"
        title={(
          <div className={styles.popover__title}>
            <div
              className={classnames({
                [styles.popover__status]: true,
                [styles['popover__status--validated']]: status === 300,
                [styles['popover__status--to-evaluate']]: status === 200,
              })}
            >
              {status === 300 ? 'Acceptée' : 'En cours d\'évaluation' }
            </div>
            <div className={styles.popover__location}>
              {zone.join(', ')}
            </div>
          </div>
        )}
        content={(
          <div className={styles.popover__content}>
            {categoriesKeys.map(cat => (
              <div className={styles.popover__category} key={cat}>
                <strong className={styles['popover__category-title']}>{cat}</strong> <br />{categories[cat].join(', ')}
              </div>
            ))}
            <div className={styles.popover__participants}>
              {participants}&nbsp;personne(s)
            </div>
            {parkings.length > 0 && (
            <div className={styles.popover__parkings}>
              <p>{parkings.length > 1 ? 'Parkings :' : 'Parking :'}</p>
              <ul>
                {parkings.map(parking => (
                  <li key={parking}>{parking}</li>
                ))}
              </ul>
            </div>
            )}
            <div className={styles.popover__footer}>
              {structure.length > 0 && (
                <div className={styles.popover__structure}>
                  <span>{structure}</span>
                </div>
              )}
            </div>
          </div>
        )}
        trigger="hover"
      >
        <Link
          to={{
            pathname: `/manage-request/detail/${id}`,
            state: { from: history.location.pathname },
          }}

          className={classnames({
            [styles.events__event]: true,
            [styles['events__event--validated']]: status === 300,
            [styles['events__event--to-evaluate']]: status === 200,
          })}
        >
          {categoriesKeys.map(cat => (
            <div
              key={cat}
              className={classnames({
                [styles.events__item]: true,
                [styles['events__item--multiple']]: categoriesKeys.length > 1,
              })}
            >
              {cat}&nbsp;: <br />{categories[cat].join(', ')}
            </div>
          ))}
        </Link>
      </Popover>
    </li>
  );
};

export default withRouter(CalendarCell);



// WEBPACK FOOTER //
// ./src/components/Agenda/Calendar/CalendarCell.js